import React, {useEffect, useState} from "react";
import Markdown from "react-markdown";
import css from "../../containers/courses/LessonBookings/ModifyBookingsDocumentation/MarkdownFileReader.less";

type MarkdownFileReaderProps = {
    filePath: string;
};

const MarkdownFileReader: React.FC<MarkdownFileReaderProps> = ({filePath}) => {
    const [markdownContent, setMarkdownContent] = useState<string>("");

    useEffect(() => {
        const fetchMarkdownFile = async () => {
            console.log("Attempting to fetch markdown file from:", filePath);
            try {
                const response = await fetch(filePath);

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const markdownText = await response.text();

                console.log("Fetched markdown content:", markdownText.substring(0, 100));
                setMarkdownContent(markdownText);
            } catch (error) {
                console.error("Error loading markdown file:", error);
            }
        };

        fetchMarkdownFile();
    }, [filePath]);

    return (
        <div className={css.markdownFileReader}>
            <Markdown className="markdown">{markdownContent}</Markdown>
        </div>
    );
};

export default MarkdownFileReader;
